import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Box } from 'reflexbox';

import { MailIcon } from '@treams/treams-icons';
import { Empty, Heading, Pagination, Paragraph, Skeleton, Table } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function SentEmails(props: { id: string }) {
	const { t } = useTranslation();

	const [pagination, setPagination] = useState<Pagination>({ last: 10 });

	const user = graphql.useUserQuery({
		variables: { id: props.id },
		fetchPolicy: 'network-only',
	});
	const query = graphql.useSentEmailsQuery({
		variables: { email: user.data?.user.email, ...pagination },
		skip: !user.data,
		fetchPolicy: 'network-only',
	});

	return (
		<Box mb={5}>
			<Heading mb={2}>{t('settings.employees.sentEmails.title')}</Heading>
			<Paragraph mb={3}>{t('settings.employees.sentEmails.description')}</Paragraph>
			<Table>
				<Table.Header>
					<Table.Cell basis={0.3}>{t('settings.employees.sentEmails.columns.sentAt')}</Table.Cell>
					<Table.Cell basis={0.3}>{t('settings.employees.sentEmails.columns.email')}</Table.Cell>
					<Table.Cell basis={0.4}>{t('settings.employees.sentEmails.columns.subject')}</Table.Cell>
				</Table.Header>
				{query.data ? (
					query.data.sentEmails.edges.length === 0 ? (
						<Skeleton.Empty
							contents={
								<Empty
									small
									icon={<MailIcon />}
									title={t('settings.employees.sentEmails.empty.title')}
									description={t('settings.employees.sentEmails.empty.description')}
								/>
							}
						>
							<Skeleton.Repeat count={3}>
								<Table.Row>
									<Table.Cell.Skeleton basis={0.3} />
									<Table.Cell.Skeleton basis={0.3} />
									<Table.Cell.Skeleton basis={0.4} />
								</Table.Row>
							</Skeleton.Repeat>
						</Skeleton.Empty>
					) : (
						<>
							{query.data.sentEmails.edges.slice().map(({ node }) => (
								<Table.Row key={node.id}>
									<Table.Cell basis={0.3}>
										{moment(node.sentAt).format('DD MMM YYYY, HH:mm')}
									</Table.Cell>
									<Table.Cell basis={0.3}>{node.recipientEmail}</Table.Cell>
									<Table.Cell basis={0.4}>{node.subject}</Table.Cell>
								</Table.Row>
							))}
						</>
					)
				) : (
					<Skeleton.Repeat count={10}>
						<Table.Row>
							<Table.Cell.Skeleton basis={0.3} />
							<Table.Cell.Skeleton basis={0.3} />
							<Table.Cell.Skeleton basis={0.4} />
						</Table.Row>
					</Skeleton.Repeat>
				)}
			</Table>
			<Table.Paging
				pageInfo={query.data?.sentEmails.pageInfo as graphql.PageInfo}
				onPaginate={setPagination}
			/>
		</Box>
	);
}
